import api from "@/services/api";

const _http = {
    async getAll(query = {}) {
    try {
        const response = await api.get("/device-type", { params: query });
        return response;
    } catch (error) {
        console.error("Device Type Service Error:", error.response?.data || error.message);
        throw error;
    }
},
    async create(data) {
        return api.post("/device-type", data);
    },
    async update(id, data) {
        return api.put(`/device-type/${id}`, data);
    },
    async updateStatus(id, is_active) {
        return api.put(`/device-type/${id}/status`, { is_active });
    },
};



export default {
    async getAll(query = {}) {
        try {
            
            const res = await _http.getAll(query);
            return {
                data: res.data.data.map((deviceType) => deviceType),
            };
        } catch (error) {
            console.error(error);
            return {
                data: [],
            };
        }
    },
    async create (payload) {
        try {
            const response = await _http.create(payload);
            return response.data;
        } catch (error) {
            console.error("Error creating device type:", error);
            throw error;
        }
    },

    async update (id, payload) {
        try {
            const response = await _http.update(id, payload);
            return response.data;
        } catch (error) {
            console.error("Error updating device type:", error);
            throw error;
        }
    },

    async updateStatus(id, status) {
        try {
            const response = await _http.updateStatus(id, status);
            return response.data;
        } catch (error) {
            console.error("Error updating device type status:", error);
            throw error;
        }
    },
}

